import { Box } from '@mui/material'
import { FC } from 'react'
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone'
import { FileDragAndDropzonePreview } from './molecules/FileDragAndDropzonePreview'
import { FileDragAndDropzoneUpload } from './molecules/FileDragAndDropzoneUpload'

type Props = {
  file?: File
  rootProps: DropzoneRootProps
  inputProps: DropzoneInputProps
  setFile: (file: File | undefined) => void
}

export const FileDragAndDropzone: FC<Props> = props => {
  const { file, rootProps, inputProps, setFile } = props

  return file ? (
    <FileDragAndDropzonePreview
      rootProps={rootProps}
      file={{
        name: file.name,
        size: file.size,
      }}
      setFile={setFile}
    />
  ) : (
    <Box height='100%'>
      <FileDragAndDropzoneUpload rootProps={rootProps} inputProps={inputProps} />
    </Box>
  )
}
